var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_delete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.17639 4.70703H4.47051H14.8235",
    stroke: "#F9F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.41151 4.70542V3.41131C6.41151 3.06808 6.54786 2.73892 6.79055 2.49623C7.03325 2.25353 7.36241 2.11719 7.70563 2.11719H10.2939C10.6371 2.11719 10.9663 2.25353 11.2089 2.49623C11.4516 2.73892 11.588 3.06808 11.588 3.41131V4.70542M13.5292 4.70542V13.7642C13.5292 14.1075 13.3928 14.4366 13.1501 14.6793C12.9074 14.922 12.5783 15.0584 12.235 15.0584H5.76445C5.42123 15.0584 5.09207 14.922 4.84938 14.6793C4.60668 14.4366 4.47034 14.1075 4.47034 13.7642V4.70542H13.5292Z",
    stroke: "#F9F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.70569 7.94141V11.8238",
    stroke: "#F9F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.2935 7.94141V11.8238",
    stroke: "#F9F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDelete);
export default __webpack_public_path__ + "static/media/ic_delete.f315200029f9fd50cad5a8781a28b0f2.svg";
export { ForwardRef as ReactComponent };